import { ILyraConfig } from '@/core/modules/lyra/@types';

/**
 * Lyra config object
 */
const lyraConfig: ILyraConfig = {
	orgKey: '05a203d85ee01909eaf728dc16f0f6cb',
	projectKey: 'd4cfeeabbd82c8682011d080f3903978',
	sessionStorageLabel: 'lyra_localisation',
	localisations: [
		{ localisation: 'en-gl', default: true },
	]
};

export default lyraConfig;